import { AxiosResponse } from 'axios'

import { _axios } from './axios'

const SECURITY_REVIEW_CLEAN_UP = '/workflow/security-review-cleanup'
const CONTRACT_BILLING_CLEAN_UP = '/workflow/order-contract-billing-clean-up'

export const workFlowApi = () => {
  const securityReviewCleanup = async (): Promise<
    AxiosResponse<{ orderMsg: string; securityMsg: string; assignMsg: string }>
  > => {
    return await _axios()
      .post(SECURITY_REVIEW_CLEAN_UP)
      .then((res) => {
        const data = {
          orderMsg: res.data.orderMsg,
          securityMsg: res.data.orderMsg,
          assignMsg: res.data.assignMsg,
        }

        res.data = data
        return res
      })
  }

  const contractBillingCleanup = async (): Promise<AxiosResponse<string>> => {
    return await _axios()
      .post(CONTRACT_BILLING_CLEAN_UP)
      .then((res) => {
        return res
      })
  }

  return {
    securityReviewCleanup,
    contractBillingCleanup,
  }
}
